import React from 'react';
import { Select as AntSelect } from 'antd-v5';
import Checkbox from '../Checkbox';
import downImg from '@/common/images/down.png';
import clearImg from '@/common/images/clear.png';
import './style.less';
const { Option: AntOption } = AntSelect;
function Select(props) {
  const {
    value,
    options,
    children,
    multiple = false,
    allowClear = true,
    maxTagTextLength = 8,
    ...nativeProps
  } = props;

  return (
    <AntSelect
      {...nativeProps}
      value={value}
      maxTagTextLength={maxTagTextLength}
      className={`ui-select ${nativeProps.className}`}
      allowClear={
        allowClear
          ? { clearIcon: <img src={clearImg} alt='clear' style={{ width: 16, height: 16 }} /> }
          : false
      }
      mode={multiple ? 'multiple' : undefined}
      optionFilterProp='label'
      suffixIcon={<img src={downImg} alt='down' style={{ width: 16, height: 16 }} />}
      dropdownClassName='ui-select-dropdown'
      optionRender={(option) => {
        const isSelected = multiple ? value?.includes(option.value) : option.value === value;
        if (multiple) {
          return (
            <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
              <Checkbox checked={isSelected}></Checkbox>
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  marginLeft: 4,
                  fontWeight: 400,
                  color: '#181818',
                }}
              >
                {option.label}
              </span>
            </div>
          );
        }
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              overflow: 'hidden',
            }}
          >
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {option.label}
            </span>
            {/* {isSelected && (
              <img
                src={selectedImg}
                alt='selected'
                style={{ width: 16, height: 16, marginLeft: 4 }}
              />
            )} */}
          </div>
        );
      }}
    >
      {children ||
        options?.map((opt) => (
          <AntOption key={opt.value} value={opt.value} label={opt.label} disabled={opt.disabled}>
            {opt.label}
          </AntOption>
        ))}
    </AntSelect>
  );
}
Select.Option = AntOption;
export default Select;
